<app-breadcrumb [title]="'Всички Заявки за Услуги'" [items]="['Услуги']" [active_item]="'Всички Заявки'"></app-breadcrumb>
<ng-container *ngIf="isLoaded">

  <!-- Filter Panel -->
  <div class="filter-panel">
    <div class="filter-header">
      <h5 class="filter-title">Филтри</h5>
      <div class="filter-header-actions">
        <button type="button" class="btn btn-link btn-sm toggle-extended-btn" (click)="toggleColumnConfig()">
          <i class="bi bi-gear"></i>
          Колони
        </button>
        <button type="button" class="btn btn-link btn-sm toggle-extended-btn" (click)="toggleExtendedFilters()">
          <i class="bi" [ngClass]="showExtendedFilters ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          {{ showExtendedFilters ? 'Скрий Разширени Филтри' : 'Покажи Разширени Филтри' }}
        </button>
      </div>
    </div>

    <!-- Column Configuration Panel -->
    <div class="column-config-panel" *ngIf="showColumnConfig">
      <div class="column-config-header">
        <h6 class="column-config-title">
          <i class="bi bi-columns-gap"></i>
          Конфигурация на Колони
        </h6>
        <div class="column-config-actions">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="resetColumnsToDefault()">
            <i class="bi bi-arrow-counterclockwise"></i> По Подразбиране
          </button>
          <button type="button" class="btn btn-sm btn-outline-primary" (click)="showAllColumns()">
            <i class="bi bi-check-all"></i> Всички
          </button>
          <button type="button" class="btn btn-sm btn-outline-danger" (click)="hideAllColumns()">
            <i class="bi bi-x-lg"></i> Никакви
          </button>
        </div>
      </div>
      <div class="column-config-body">
        <div class="row g-2">
          <div class="col-md-3" *ngFor="let column of columns">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'col-' + column.key"
                [(ngModel)]="column.visible">
              <label class="form-check-label" [for]="'col-' + column.key">
                {{column.label}}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Default Filters (Always Visible) -->
    <div class="row g-3 mb-3">
      <div class="col-md-3">
        <label class="form-label">Заявител</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.requestor" (ngModelChange)="applyFilters()" placeholder="Търси по име...">
      </div>
      <div class="col-md-3">
        <label class="form-label">ЕГН</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.egn" (ngModelChange)="applyFilters()" placeholder="Търси по ЕГН...">
      </div>
      <div class="col-md-3">
        <label class="form-label">УРИ</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.uri" (ngModelChange)="applyFilters()" placeholder="Търси по УРИ...">
      </div>
      <div class="col-md-3">
        <label class="form-label">RNU</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.rnu" (ngModelChange)="applyFilters()" placeholder="Търси по RNU...">
      </div>
    </div>
    <div class="row g-3 mb-3">
      <div class="col-md-3">
        <label class="form-label">Име на Услуга</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.serviceName" (ngModelChange)="applyFilters()" placeholder="Търси по име...">
      </div>
    </div>

    <!-- Extended Filters (Collapsible) -->
    <div class="extended-filters" *ngIf="showExtendedFilters">
      <div class="extended-filters-divider"></div>
      <h6 class="extended-filters-title">Разширени Филтри</h6>

      <div class="row g-3">
        <!-- Row 1: Service Type and Tax Filters -->
        <div class="col-md-3">
          <label class="form-label">Тип Услуга</label>
          <input type="text" class="form-control form-control-sm" [(ngModel)]="filters.serviceType" (ngModelChange)="applyFilters()" placeholder="Търси по тип...">
        </div>
        <div class="col-md-3">
          <label class="form-label">Такса От</label>
          <input type="number" class="form-control form-control-sm" [(ngModel)]="filters.providerTaxMin" (ngModelChange)="applyFilters()" placeholder="Мин. такса" step="0.01">
        </div>
        <div class="col-md-3">
          <label class="form-label">Такса До</label>
          <input type="number" class="form-control form-control-sm" [(ngModel)]="filters.providerTaxMax" (ngModelChange)="applyFilters()" placeholder="Макс. такса" step="0.01">
        </div>
        <div class="col-md-3">
          <label class="form-label">Отговор</label>
          <select class="form-select form-select-sm" [(ngModel)]="filters.responseType" (ngModelChange)="applyFilters()">
            <option [ngValue]="null">Всички</option>
            <option *ngFor="let type of responseTypes" [ngValue]="type.value">{{type.label}}</option>
          </select>
        </div>

        <!-- Row 2: Shipping Method, Status, and Date Filters -->
        <div class="col-md-3">
          <label class="form-label">Метод за Доставка</label>
          <select class="form-select form-select-sm" [(ngModel)]="filters.shippingMethod" (ngModelChange)="applyFilters()">
            <option [ngValue]="null">Всички</option>
            <option *ngFor="let method of shippingMethods" [ngValue]="method.idShippingMethod">{{method.name}}</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Статус</label>
          <select class="form-select form-select-sm" [(ngModel)]="filters.status" (ngModelChange)="applyFilters()">
            <option [ngValue]="null">Всички</option>
            <option *ngFor="let status of statuses" [ngValue]="status.value">{{status.label}}</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">От Дата</label>
          <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.fromDate" (ngModelChange)="applyFilters()">
        </div>
        <div class="col-md-3">
          <label class="form-label">До Дата</label>
          <input type="date" class="form-control form-control-sm" [(ngModel)]="filters.toDate" (ngModelChange)="applyFilters()">
        </div>
      </div>
    </div>

    <!-- Filter Actions and Results -->
    <div class="filter-footer">
      <button type="button" class="btn btn-secondary btn-sm" (click)="clearAllFilters()">
        <i class="bi bi-x-circle"></i> Изчисти Всички Филтри
      </button>
      <small class="text-muted">Показани резултати: <strong>{{filteredServices?.length || 0}}</strong> от <strong>{{services?.length || 0}}</strong></small>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col" *ngIf="isColumnVisible('requestor')">Заявител</th>
          <th scope="col" *ngIf="isColumnVisible('egn')">ЕГН</th>
          <th scope="col" *ngIf="isColumnVisible('responseType')">Отговор</th>
          <th scope="col" *ngIf="isColumnVisible('serviceName')">Вид услуга</th>
          <th scope="col" *ngIf="isColumnVisible('serviceType')">Услуга</th>
          <th scope="col" *ngIf="isColumnVisible('uri')">УРИ</th>
          <th scope="col" *ngIf="isColumnVisible('rnu')">RNU</th>
          <th scope="col" *ngIf="isColumnVisible('provider')">Доставчик</th>
          <th scope="col" *ngIf="isColumnVisible('providerTax')">Доставчик такса</th>
          <th scope="col" *ngIf="isColumnVisible('agent')">Посредник</th>
          <th scope="col" *ngIf="isColumnVisible('shippingMethod')">Метод за Доставка</th>
          <th scope="col" *ngIf="isColumnVisible('deliveryDate')">Дата на Доставка</th>
          <th scope="col" *ngIf="isColumnVisible('status')">Статус Заявка</th>
          <th scope="col" *ngIf="isColumnVisible('paymentStatus')">Статус Плащане</th>
          <th scope="col" *ngIf="isColumnVisible('requestDate')">Дата на Заявяване</th>
          <th scope="col" *ngIf="isColumnVisible('organization')">Организация</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let service of filteredServices" [ngClass]="!isSelected(service)?'':'selected-cell'" (click)="onSelected(service)">
          <td *ngIf="isColumnVisible('requestor')">{{getRequestorNames(service)}}</td>
          <td *ngIf="isColumnVisible('egn')">{{service.egn}}</td>
          <td *ngIf="isColumnVisible('responseType')">{{GetResponseType(service)}}</td>
          <td *ngIf="isColumnVisible('serviceName')" [title]="service.deliverService.title">{{truncateText(service.deliverService.title, 50)}}</td>
          <td *ngIf="isColumnVisible('serviceType')" [title]="getServiceName(service)">{{truncateText(getServiceName(service), 50)}}</td>
          <td *ngIf="isColumnVisible('uri')">{{getURI(service)}}</td>
          <td *ngIf="isColumnVisible('rnu')">{{service.rnu || 'N/A'}}</td>
          <td *ngIf="isColumnVisible('provider')">{{service.deliverService.serviceProvider.serviceProviderName}}</td>
          <td *ngIf="isColumnVisible('providerTax')">{{service.serviceProviderTax}}</td>
          <td *ngIf="isColumnVisible('agent')">{{getAgentName(service)}}</td>
          <td *ngIf="isColumnVisible('shippingMethod')">{{getShippingMethodName(service)}}</td>
          <td *ngIf="isColumnVisible('deliveryDate')">{{getDeliveredDate(service)}}</td>
          <td *ngIf="isColumnVisible('status')">{{getTranslatedStatus(service.status)}}</td>
          <td *ngIf="isColumnVisible('paymentStatus')">
            <span [class]="getPaymentBadgeClass(service)">{{getPaymentStatusText(service)}}</span>
          </td>
          <td *ngIf="isColumnVisible('requestDate')">{{getDate(service)}}</td>
          <td *ngIf="isColumnVisible('organization')">{{getOrganizationName(service)}}</td>
        </tr>

      </tbody>
    </table>
  </div>
</ng-container>
<ng-container *ngIf="!isLoaded">
<div style="text-align: center;">
  <div class="spinner-grow spinner-grow-sm" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 30px; height: 30px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 40px; height: 40px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 50px; height: 50px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
</ng-container>
